import { stratdotBlogRecommendations } from '@/mocks/homeBlog';
import { clamp, TRANSITION, COLORS } from './progress';

interface BlogSceneProps {
  progress: number;
}

export default function BlogScene({ progress }: BlogSceneProps) {
  const p = clamp(progress, 0, 1);
  const enter = clamp(p * 3, 0, 1);
  const exit = 1 - clamp((p - 0.84) * 6, 0, 1);
  const opacity = Math.min(enter, exit);
  const translateY = (1 - enter) * 60;
  const articles = stratdotBlogRecommendations.slice(0, 2);

  return (
    <div
      className="absolute inset-0 z-20 flex items-center justify-center px-5 md:px-8 pt-20 md:pt-24 pb-10 pointer-events-none"
      style={{ opacity, transform: `translateY(${translateY}px)`, transition: TRANSITION, willChange: 'transform, opacity' }}
    >
      <div className="w-full max-w-5xl">
        <div className="flex items-center gap-3 mb-5 md:mb-7">
          <span className="w-8 h-px" style={{ backgroundColor: COLORS.amber }} />
          <span className="font-manrope text-white/70 text-[10px] uppercase tracking-[0.35em]">
            Vol. 05 — 編輯選書
          </span>
        </div>

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-5 md:mb-7">
          <h2 className="font-semibold text-white text-2xl md:text-3xl">
            策點文化的編輯選書
          </h2>
          <p className="font-manrope text-xs md:text-sm text-white/55 leading-relaxed max-w-md line-clamp-2">
            從最新出版內容出發，先讀一段編輯為你整理的閱讀入口，再決定下一本書要帶你走向哪裡。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 pointer-events-auto">
          {articles.map((article) => (
            <article
              key={article.id}
              className="flex gap-4 p-3 md:p-4 border"
              style={{ backgroundColor: 'rgba(255,255,255,0.05)', borderColor: COLORS.line }}
            >
              <div className="w-20 md:w-28 flex-shrink-0 aspect-[3/4] overflow-hidden bg-black/20">
                <img
                  src={article.coverImage}
                  alt={`${article.title} 封面`}
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>
              <div className="min-w-0 flex flex-col">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mb-2">
                  <span className="font-manrope text-[10px] tracking-[0.16em]" style={{ color: COLORS.cyan }}>
                    {article.category}
                  </span>
                  <span className="font-manrope text-[10px] text-white/35">{article.publishDate}</span>
                </div>
                <h3 className="font-semibold text-white text-sm md:text-base leading-relaxed mb-2 line-clamp-3">
                  {article.title}
                </h3>
                <p className="font-manrope text-[11px] md:text-xs text-white/60 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
